
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as verifyl1suJ3zT7AL2RaLcTuuojB_8UsVA3kw9L_gPZi3lvLwMeta } from "/app/pages/verify.vue?macro=true";
import { default as faq5rz6i7x7WGoAgG1GOLJzL_4531oTMcvENEuAh_wcDg5AMMeta } from "/app/pages/info/faq.vue?macro=true";
import { default as registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta } from "/app/pages/register.vue?macro=true";
import { default as indexBN_PyuODBq4eSxq0GppjpQJwY3SuQ1tH7SjTZibfHMYMeta } from "/app/pages/chat/index.vue?macro=true";
import { default as indexuTyeO7hnPpnQ4M9r2IWtvM8x5DI_2BwM7uBxDJ_45VElAMeta } from "/app/pages/info/index.vue?macro=true";
import { default as _91_46_46_46id_93vOumBwWsJaaFdzWzrW7k9OFUpHxE0dM_45N1NSczV6ekEMeta } from "/app/pages/chat/[...id].vue?macro=true";
import { default as privacyHI68J1LVNyJPPyal8p2oV2v5fDOz2ZBxU9EXGbuZqlgMeta } from "/app/pages/info/privacy.vue?macro=true";
import { default as aanvragenpo_om6p_45t5BK9gtuGaQoCWrHhe_45xp0f0yo3W8k6_45rr4Meta } from "/app/pages/info/aanvragen.vue?macro=true";
import { default as reset_45passwordiWFFQc4mqHAplbYzhpvNKouyr6Qp9Bvu_45FM1ScN8_pgMeta } from "/app/pages/reset-password.vue?macro=true";
import { default as _91provider_93BMLfw6SlSSRMfvRVflY8cgfLWhh6wDVqoIJz1o90yOAMeta } from "/app/pages/auth/[provider].vue?macro=true";
import { default as forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta } from "/app/pages/forgot-password.vue?macro=true";
import { default as indexf8iutw6yHmDgCeGVn5zagDJu_45QqxKni3nhljnOU6upYMeta } from "/app/pages/cao-request/index.vue?macro=true";
import { default as algemene_45voorwaardenryAd3P1LYaF_453YmLzzIEhZPWhsRQfwYS_gfR5gCgPPkMeta } from "/app/pages/info/algemene-voorwaarden.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "verify",
    path: "/verify",
    meta: verifyl1suJ3zT7AL2RaLcTuuojB_8UsVA3kw9L_gPZi3lvLwMeta || {},
    component: () => import("/app/pages/verify.vue")
  },
  {
    name: "info-faq",
    path: "/info/faq",
    meta: faq5rz6i7x7WGoAgG1GOLJzL_4531oTMcvENEuAh_wcDg5AMMeta || {},
    component: () => import("/app/pages/info/faq.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "chat",
    path: "/chat",
    component: () => import("/app/pages/chat/index.vue")
  },
  {
    name: "info",
    path: "/info",
    meta: indexuTyeO7hnPpnQ4M9r2IWtvM8x5DI_2BwM7uBxDJ_45VElAMeta || {},
    component: () => import("/app/pages/info/index.vue")
  },
  {
    name: "chat-id",
    path: "/chat/:id(.*)*",
    component: () => import("/app/pages/chat/[...id].vue")
  },
  {
    name: "info-privacy",
    path: "/info/privacy",
    meta: privacyHI68J1LVNyJPPyal8p2oV2v5fDOz2ZBxU9EXGbuZqlgMeta || {},
    component: () => import("/app/pages/info/privacy.vue")
  },
  {
    name: "info-aanvragen",
    path: "/info/aanvragen",
    meta: aanvragenpo_om6p_45t5BK9gtuGaQoCWrHhe_45xp0f0yo3W8k6_45rr4Meta || {},
    component: () => import("/app/pages/info/aanvragen.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordiWFFQc4mqHAplbYzhpvNKouyr6Qp9Bvu_45FM1ScN8_pgMeta || {},
    component: () => import("/app/pages/reset-password.vue")
  },
  {
    name: "auth-provider",
    path: "/auth/:provider()",
    meta: _91provider_93BMLfw6SlSSRMfvRVflY8cgfLWhh6wDVqoIJz1o90yOAMeta || {},
    component: () => import("/app/pages/auth/[provider].vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "cao-request",
    path: "/cao-request",
    component: () => import("/app/pages/cao-request/index.vue")
  },
  {
    name: "info-algemene-voorwaarden",
    path: "/info/algemene-voorwaarden",
    meta: algemene_45voorwaardenryAd3P1LYaF_453YmLzzIEhZPWhsRQfwYS_gfR5gCgPPkMeta || {},
    component: () => import("/app/pages/info/algemene-voorwaarden.vue")
  }
]